import { render } from "./RouteTable.vue?vue&type=template&id=5c032c7a&scoped=true"
import script from "./RouteTable.vue?vue&type=script&lang=js"
export * from "./RouteTable.vue?vue&type=script&lang=js"

import "./RouteTable.vue?vue&type=style&index=0&id=5c032c7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c032c7a"]])

export default __exports__